<template>
  <div class="fr">
    <div class="icon_avatar" @click="onMaskOpen"></div>
    <div class="mask" @click="onMaskClose" v-show="maskVisible">
      <div class="container" @click.stop>
        <div class="user_name">{{ userName }}</div>
        <PortalSwitch v-if="isIb" @click="goToIbPortal"></PortalSwitch>
        <div
          class="item verification_status"
          @click="
            $router.push(RegisterRoutePath.register);
            maskVisible = false;
          "
        >
          <div class="icon" />
          <span>{{ $t('menu.verificationStatus') }}</span>
          <span v-if="!(accountAuditStatus === auditStatus.completed && idPass && poaPass)" class="continue_tag">{{
            $t('common.button.continue')
          }}</span>
        </div>
        <template v-if="showLang">
          <div class="item group/item" @click="onLanguageTrigger">
            <img class="icon" :src="language.icon" alt="" />
            <span v-html="language.label"></span>
            <svg-icon
              iconName="chevron-up"
              :className="`${languageVisible ? '' : 'rotate-180'} arrow group-hover/item:text-blueG0 !w-2.5 !h-1.5`"
            ></svg-icon>
          </div>
          <transition name="el-zoom-in-top">
            <div class="language_container" v-show="languageVisible">
              <div class="lang" v-for="item in languages" :key="item.value" @click="onLanguageChange(item)">
                <img class="icon" :src="item.icon" alt="" />
                <span>{{ item.label }}</span>
                <!-- <img
                  class="check"
                  v-if="lang == item.value"
                  src="@/assets/images/new/icon_check_dark.png"
                  alt="icon_check_dark"
                /> -->
              </div>
            </div>
          </transition>
        </template>

        <div class="item logout" @click="onLogout">
          <div class="icon" />
          <span>{{ $t('common.button.logout') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PortalSwitch from './PortalSwitch.vue';
import { mapGetters, mapState } from 'vuex';
import auditStatus from '@/constants/auditStatus';
import { RegisterRoutePath } from '@/router/registerRoutes';

export default {
  name: 'MobileAvatar',
  components: {
    PortalSwitch
  },
  props: {
    userName: {
      type: String,
      default: ''
    },
    language: {
      type: Object,
      default: () => ({})
    },
    lang: {
      type: String,
      default: ''
    },
    languages: {
      type: Array,
      default: () => []
    },
    showLang: {
      type: Boolean,
      default: true
    },
    isIb: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      maskVisible: false,
      languageVisible: false
    };
  },
  computed: {
    ...mapState('common', ['openAccountEnabled', 'accountAuditStatus']),
    ...mapGetters('common', ['idPass', 'poaPass'])
  },
  methods: {
    onMaskOpen() {
      this.maskVisible = true;
    },
    goToIbPortal() {
      this.$emit('click');
    },
    onMaskClose() {
      this.maskVisible = false;
    },
    onLanguageTrigger() {
      this.languageVisible = !this.languageVisible;
    },
    onLanguageClose() {
      this.languageVisible = false;
    },
    onLanguageChange(value) {
      this.$emit('onLanguageChange', value);
    },
    onLogout() {
      this.$emit('onLogout');
    }
  },
  created() {
    this.auditStatus = auditStatus;
    this.RegisterRoutePath = RegisterRoutePath;
  }
};
</script>

<style lang="scss" scoped>
.icon_avatar {
  width: 30px;
  height: 30px;
  background: url('~@/assets/images/header/header_icon.png') center no-repeat;
  background-size: 32px 32px;
  border-radius: 50%;
  cursor: pointer;

  &:hover {
    background-image: url('~@/assets/images/header/header_black.png');
  }
}

$offsetTop: 60px;
.mask {
  position: fixed;
  top: $offsetTop;
  left: 0;
  z-index: 99999999;
  width: 100%;
  height: 100%;
  background-color: rgba(145, 145, 145, 0.63);

  .container {
    position: absolute;
    top: 0;
    @include rtl-sass-prop(right, left, 0);
    width: 62%;
    box-sizing: border-box;
    background-color: #fff;
    padding: 20px 14px;
    height: 100%;

    .user_name {
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: $primary-dark-blue;
    }

    .item {
      display: flex;
      align-items: center;
      color: $primary-dark-blue;
      font-size: 14px;
      line-height: 24px;
      font-weight: 500;
      padding: 8px 0;
      margin-top: 16px;
      cursor: pointer;

      &.verification_status {
        .icon {
          background-image: url(~@/assets/images/header/status_black.png);
        }
        &:hover {
          .icon {
            background-image: url(~@/assets/images/header/status_icon.png);
          }
        }
      }

      &.logout {
        .icon {
          background-image: url(~@/assets/images/header/logout_black.png);
        }

        &:hover {
          .icon {
            background-image: url(~@/assets/images/header/logout_blue.png);
          }
        }
      }

      .icon {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        @include rtl-sass-prop(margin-right, margin-left, 8px);
        background-repeat: no-repeat;
        background-position: 0 0;
        background-size: cover;
      }

      span {
        flex: 1;
      }

      &:hover span {
        color: $primary-blue;
      }

      .arrow {
        @include rtl-sass-prop(margin-left, margin-right, 8px);
      }
    }

    .language_container {
      overflow-y: scroll;
      max-height: 300px;
      background-color: #f7f7f7;
      padding: 16px;

      .lang {
        color: $primary-dark-blue;
        font-size: 14px;
        display: flex;
        align-items: center;
        cursor: pointer;
        & + .lang {
          margin-top: 20px;
        }
        .icon {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          object-fit: cover;
          border: 1px solid #fff;
          @include rtl-sass-prop(margin-right, margin-left, 8px);
        }

        span {
          flex: 1;
        }
        &:hover span {
          color: $primary-blue;
        }

        .check {
          width: 16px;
        }
      }
    }
  }
}

.continue_tag {
  margin-left: 8px;
  font-weight: 600;
  font-size: 10px;
  color: #fff !important;
  padding: 0px 10px 0 8px;
  border-radius: 30px;
  background: #0051ff;
  background: linear-gradient(50.88deg, #0051ff 13.57%, #00ffff 138.48%);
  text-transform: uppercase;
  font-style: italic;
  text-align: center;
  flex: unset !important;
}
</style>
